import React from 'react';
import UpdateRoundedIcon from '@mui/icons-material/UpdateRounded';
import AutorenewRoundedIcon from '@mui/icons-material/AutorenewRounded';
import OutlinedFlagRoundedIcon from '@mui/icons-material/OutlinedFlagRounded';
import FlagRoundedIcon from '@mui/icons-material/FlagRounded';
import { Tooltip } from '@mui/material';
import { shape, number, string, bool } from 'prop-types';

/**
 * Renders shipment status icon based on status code.
 * Provides tooltip with status label.
 * @returns {React.FC}
 */

const ShipmentStatus = ({
  status: { code, label } = {},
  showTooltip = false
}) => {
  let Icon;

  switch (code) {
    case 4:
    case 400:
      Icon = FlagRoundedIcon;
      break;
    case 3:
    case 300:
      Icon = OutlinedFlagRoundedIcon;
      break;
    case 2:
    case 200:
      Icon = AutorenewRoundedIcon;
      break;
    case 1:
    case 100:
      Icon = UpdateRoundedIcon;
      break;
    default:
      Icon = UpdateRoundedIcon;
  }

  if (showTooltip) {
    return (
      <Tooltip title={label}>
        <Icon />
      </Tooltip>
    );
  }
  return <Icon />;
};

ShipmentStatus.propTypes = {
  status: shape({
    code: number,
    label: string
  }),
  showTooltip: bool
};

export default ShipmentStatus;
